import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUpperCase]',
  standalone: true
})
export class UpperCaseDirective {
  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;

    const upper = input.value.toUpperCase();
    this.control.control?.setValue(upper, { emitEvent: false });
  }
}